import React, { Children, PropsWithChildren } from 'react';
import { TooltipRoot } from './Tooltip.styled';
import { TooltipColors, TooltipVariant } from './Tooltip.props';
import { usePopperTooltip } from 'react-popper-tooltip';
import * as PopperJS from '@popperjs/core';

type Props = {
	message?: string;
	placement?: PopperJS.Placement;
	variant?: TooltipVariant;
	delayHide?: number;
	delayShow?: number;
}

export function Tooltip(
	{
		message,
		children,
		placement = 'auto',
		variant = 'default',
		delayHide = 100,
		delayShow = 0,
	}: PropsWithChildren<Props>
) {

	const {
		getArrowProps,
		getTooltipProps,
		setTooltipRef,
		setTriggerRef,
		visible,
	} = usePopperTooltip({
		interactive: true,
		delayHide,
		delayShow,
		placement,
	});

	if (!message) {
		return <>{children}</>;
	}

	const colorDefinition = TooltipColors[variant];

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const child = Children.only(children) as React.ReactElement & { ref?: React.Ref<any> };

	return (
		<>
			{React.cloneElement(child, { ref: setTriggerRef })}
			{visible && (
				<TooltipRoot
					$colorDefinition={colorDefinition}
					ref={setTooltipRef}
					{...getTooltipProps({ className: 'tooltip-container' })}>
					{message}
					<div {...getArrowProps({ className: 'tooltip-arrow' })} />
				</TooltipRoot>
			)}
		</>
	);
}

